import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, TouchableOpacity, TextInput } from "react-native";
 import { Button, View, Text } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
import { withTranslation } from "react-i18next";
import MessageBox from "../../components/ui/MessageBox";
import FeedbackSuggestionService from "../../services/screens/me/FeedbackSuggestionService";
import UIDs from "../../UIDs";

const uid = UIDs.components.ui.unitissuereportmodal;

class UnitIssueReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showReportError: false,
            reportErrorCode: 0,
            description: "",
        }
    }

    //纠错
    renderReason(reason, index) {
        const selected = (this.state.reportErrorCode === reason.code);
        return (<Button key={index} style={{height: 40, backgroundColor: (selected ? "#cc0000" : "#eee"),
                                    marginRight: 8, marginBottom: 8,
                                    borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                transparent onPress={() => {
                    this.setState({
                            reportErrorCode: selected ? -1 : reason.code,
                            description: "",
                        });
                }}
        >
            <Text style={{color: selected ? '#fff' : '#666'}}>{reason.text}</Text>
        </Button>);
    }

    _sendReportError(id, type, childUnitIndex) {
        let reportAPI = FeedbackSuggestionService.reportUnitError;

        if (reportAPI) {
            reportAPI({id: id, type, childUnitIndex, errorCode: this.state.reportErrorCode, description: this.state.description},
                      (response) => {
                          this.setState({showReportError: false, reportErrorCode: 0, description: ""});
                          MessageBox.success({
                              text: this.props.t("reportSuccess"),
                              duration: 5000
                          });
                      },
                      (response) => {
                          this.setState({showReportError: false, reportErrorCode: 0, description: ""});
                          MessageBox.danger({
                              text: this.props.t("reportError"),
                              duration: 5000
                          });
                      });
        }
        else {
            this.setState({showReportError: false, reportErrorCode: 0, description: ""});
        }
    }

    renderReportError(id, type, childUnitIndex) {
        const reasons = [
            {code: 0, text: this.props.t('hasError')},
            {code: 1, text: this.props.t('pinyinError')},
            {code: 2, text: this.props.t('interpretError')},
            {code: 3, text: this.props.t('pronounceError')},
            {code: 4, text: this.props.t('contentError')},
            {code: 5, text: this.props.t('answerError')},
            {code: 6, text: this.props.t('otherError')},
        ];
        return (
            <Modal>
                <View style={{flex:1, alignItems: 'center', justifyContent: 'center'}}>
                    <View style={{width: 900, height:"90%",
                          backgroundColor: '#fff', paddingLeft: 20, paddingRight: 20, paddingBottom: 20}}>
                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <Text style={{fontSize: 20}}>
                                {this.props.t("reportUnitError")}
                            </Text>
                        </View>
                        <View style={{marginTop: 20, flexDirection: 'row', flexWrap: "wrap"}}>
                            {reasons.map((reason, index) => {
                                return this.renderReason(reason, index);
                            })}
                        </View>
                        <View style={{flex: 1,}}>
                            {
                                this.state.reportErrorCode === 6 ?
                                    <TextInput ref={"description"}
                                        multiline={true}
                                        onContentSizeChange={this.onContentSizeChange.bind(this)}
                                        onChangeText={text => this.setState({ description: text })}
                                        placeholder={this.props.t("otherErrorDescription")}
                                        value={this.state.description}
                                        placeholderTextColor={"#666666"}
                                        style={{borderWidth:1, width:"100%", borderRadius:6, borderColor:"#0099FF", padding:10, height:Math.max(25,this.state.height),}}
                                    />
                                : null
                            }
                        </View>
                        <View style={{flexDirection: 'row'}}>
                            <Button style={{flex: 1, height: 40, backgroundColor: (this.state.reportErrorCode >= 0) ? "#1E90FF" : "#ccc",
                                            marginRight: 8,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                    disabled={this.state.reportErrorCode < 0}
                                    transparent onPress={() => {
                                        this._sendReportError(id, type, childUnitIndex);
                                    }}
                            >
                                <Text style={{color: '#fff'}}>{this.props.t('submitError')}</Text>
                            </Button>
                            <Button style={{flex: 1, height: 40, backgroundColor: "#fff", marginLeft: 8,
                                            borderColor: '#333', borderWidth: 1,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                    transparent onPress={() => {
                                        this.setState({showReportError: false, reportErrorCode: 0});
                                    }}
                            >
                                <Text style={{color: '#333'}}>{this.props.t('cancel')}</Text>
                            </Button>
                        </View>
                    </View>
                </View>
            </Modal>
        );
    }

    onContentSizeChange(event) {
        this.setState({height: event.nativeEvent.contentSize.height});
    }

    //纠错结束

    render() {
        let {id, type, childUnitIndex=0, style} = this.props;
        return(
            <>
                {this.state.showReportError ? this.renderReportError(id, type, childUnitIndex) : null}
                <TouchableOpacity
                    onPress={() => {
                        this._handleReportError();
                    }}
                >
                    <Icon name="ios-help-circle-outline" style={{ color: "#ffb400", fontSize: 24, marginLeft:10, marginTop:3, ...style }} />
                </TouchableOpacity>
            </>
        )
    }

    _handleReportError = () => {
        this.setState({showReportError: true, reportErrorCode: 0});
    };
}
export default withTranslation(uid)(UnitIssueReportModal);